// @flow
import React from 'react';
import classNames from 'classnames';
import { RouteNames } from 'router';
import { useViewport } from 'components/templates/viewportProvider';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  containerClass?: string,
};

export const Copyright = (props: Props) => {
  const { containerClass } = props;
  const { isMobile } = useViewport();

  const containerClassName = classNames('copyright', containerClass);

  return (
    <div className={containerClassName}>
      <span>
        {' '}
        &copy; Copyright {new Date().getFullYear()}{' '}
        {!isMobile && <span> |&nbsp;</span>}
      </span>
      <div>
        <span>
          Please read our <a href={RouteNames.terms}>Disclaimer</a> and{' '}
          <a href={RouteNames.privacy}>Privacy Policy</a>
        </span>
      </div>
    </div>
  );
};
